// Copyright © 2021 Move Closer
import { __decorate } from "tslib";
import { Component, Prop, Vue } from 'vue-property-decorator';
/**
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 */
let AbstractModule = class AbstractModule extends Vue {
    /**
     * Default module's config.
     */
    static getInitialConfig() {
        throw new Error('AbstractModuleForm.initialConfig: This field **HAS TO** be overridden by the subclass!');
    }
    /**
     * Default module's content (schema & default values).
     */
    static getInitialContent() {
        throw new Error('AbstractModuleForm.getInitialContent(): This field **HAS TO** be overridden by the subclass!');
    }
};
__decorate([
    Prop({ type: Object, required: false })
], AbstractModule.prototype, "relatedService", void 0);
AbstractModule = __decorate([
    Component({ name: 'AbstractModule' })
], AbstractModule);
export { AbstractModule };
